import React from 'react'
function Record404() {
    return (
        <div className="shadow shadow-intensity-md rounded-3 mt-4 mb-4 py-4">
            <h5 className="text-center fs-14rem">No Record Available</h5>
        </div>
    )
}
export default Record404;
